import React from 'react';

import { Icon } from '@rbilabs/component-library';
import { defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';

import ActionButton from 'components/action-button';
import Modal, { ModalContent, ModalHeading } from 'components/modal';
import { useOrderDetails } from 'hooks/use-order-details';
import { useOrderContext } from 'state/order';
import { useReorder } from 'state/order/hooks/use-reorder';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 18.75rem;
  padding-bottom: 3rem;

  ${Styles.desktop`
    max-width: 31.25rem;
  `}
`;

const Heading = styled(ModalHeading)`
  margin: 3rem 0 1rem 0;
`;

const Text = styled.p`
  margin: 0 0 3rem 0;
`;

interface IOrderCancelledModalProps {
  onDismiss: () => void;
  modalAppearanceEventMessage?: string;
}

const OrderCancelledModal: React.FC<IOrderCancelledModalProps> = ({
  onDismiss,
  modalAppearanceEventMessage = 'Order Cancelled',
}) => {
  const {
    serverOrder,
    reorder: { reordering },
  } = useOrderContext();
  const { order } = useOrderDetails(serverOrder.rbiOrderId);
  const { handleReorderClick } = useReorder(order);
  const { formatMessage } = useIntl();

  const modalHeading = formatMessage(messages.cancelledOrderTitle);
  const modalBody = formatMessage(messages.cancelledOrderAction);

  return (
    <Modal
      onDismiss={onDismiss}
      mParticleEventData={{
        modalAppearanceEventMessage,
        modalMessage: modalBody,
      }}
    >
      <ModalContent>
        <Container>
          <Icon icon="error" color="primary" width="9.5rem" height="9.5rem" />
          <Heading id="modal-heading">{modalHeading}</Heading>
          <Text>{modalBody}</Text>
          <ActionButton onClick={handleReorderClick} isLoading={reordering}>
            {formatMessage(messages.reorder)}
          </ActionButton>
        </Container>
      </ModalContent>
    </Modal>
  );
};

export default OrderCancelledModal;
const messages = defineMessages({
  reorder: {
    id: 'reorder',
    defaultMessage: 'Reorder',
    description: 'No description',
  },

  cancelledOrderAction: {
    id: 'cancelledOrderAction',
    defaultMessage:
      "We're sorry, but it looks like your order has been cancelled and refunded. If you'd like to place your order again you can use the button below.",
    description: 'No description',
  },

  cancelledOrderTitle: {
    id: 'cancelledOrderTitle',
    defaultMessage: 'Oh no! Your order was cancelled.',
    description: 'No description',
  },
});
